import { FADED_FITOGRAM_BLUE, PRIMARY_BLUE, WHITE } from '~/Constants/Colors.constants';
import { BOX_SHADOW_UNDERLINE } from '~/Constants/CSS.constants';
import { makeStyles } from '~/UIKit/Style/makeStyles';
import { EVENT_Z_INDEX } from '~/Screens/Calendar/constants';

export const useStyles = makeStyles((theme) => ({
  headerContainer: {
    marginBottom: '2px',
    padding: '0 15px',
    display: 'flex',
    overflowY: 'hidden',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: WHITE,
    boxShadow: BOX_SHADOW_UNDERLINE,
    zIndex: EVENT_Z_INDEX + 2,
  },
  icon: {
    marginRight: '7px',
  },
  datePeriodSelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  headerButtonsLeft: {
    display: 'flex',
    alignItems: 'center',
    '& > button': {
      marginRight: '28px',
    },
  },
  headerButtonsRight: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    columnGap: '20px',
  },
  arrow: {
    color: PRIMARY_BLUE,
  },
  selectedDay: {
    fontWeight: 'bold',
    marginLeft: '14px',
  },
  selectRoot: {
    border: `thin solid ${FADED_FITOGRAM_BLUE}`,
    fontSize: 12,
    color: PRIMARY_BLUE,
    fontWeight: 'bold',
    height: 28,
    borderRadius: '3px',
  },
  select: {
    padding: theme.spacing(),
  },
  selectIcon: {
    color: PRIMARY_BLUE,
  },
}));
